import * as messageService from "../../services/message.service";
import * as otherLoanService from '../../services/otherLoan.service';


const state = {
    otherLoanAll:[],
    otherLoanAllActive:[],
};

const getters = {
    gettOtherLoanAll:state => (state.otherLoanAll),
    gettOtherLoanAllActive:state => (state.otherLoanAllActive),
};

const actions = {
    async fetchOtherLoanAll({ commit } ){
        try {
            const response = await otherLoanService.all();
            commit('setOtherLoanAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchOtherLoanAllActive({ commit } ){
        try {
            const response = await otherLoanService.allActive();
            commit('setOtherLoanAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setOtherLoanAll:(state, res) => (
        state.otherLoanAll =  res
    ),
    setOtherLoanAllActive:(state, res) => (
        state.otherLoanAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}